import * as React from 'react';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { Link } from 'react-router-dom';
import InvestmentFunnelHeaderComponent from '../partials/InvestmentFunnelHeader.component';
import Project from 'src/entities/Project';
import './ExpiredData.css';

export interface ExpiredDataComponentProps {
  project: Project;
  modalRef?: Modal;
  handleClick: () => void;
}

const ExpiredDataComponent = (props: ExpiredDataComponentProps) => {
  return (
    <div className="modal-content investment-funnel-modal expired-data-modal">
      <InvestmentFunnelHeaderComponent
        logo={props.project.company.logo}
        modalRef={props.modalRef}
      />
      <div className="modal-body">
        <div className="row">
          <div className="gap-20"/>
          <p className="featured c-orange">Tu perfil tiene el DNI caducado:</p>
          <p>
            Tu perfil de inversión tiene el DNI caducado.
            Por favor, vuelve a carga tu documento de identidad por ambas caras, en el apartado correspondiente para
            poder verificar nuevamente tus datos con nuestra plataforma de pagos.
          </p>
          <p className="featured c-orange">Aviso al inversor:</p>
          <p>
            En el caso que no nos hagas llegar la documentación actualizada antes de formalizar alguna operación
            procederemos a la retirada de tu compromiso, cumpliendo así la penalización correspondiente.
          </p>
          <p className="featured c-orange">
            Penalización por retirada de la inversión: 10% del compromiso hasta 1.000€ más IVA.
          </p>
          <p>
            Si tienes alguna incidencia con la actualización del documento, no dudes en ponerte en contacto con
            nuestro equipo a través de <a href="mailto:support@thecrowdangel.com">support@thecrowdangel.com</a>
          </p>
          <div className="gap-20"/>
          <div className="action-buttons">
            <Link
              to="/mi-cuenta/tipo-de-inversor"
              onClick={() => props.modalRef!.modal('hide')}
            >
              <button className="btn btn-secondary">
                Actualizar mi perfil
              </button>
            </Link>
            <button
              className="btn btn-warning"
              onClick={() => props.handleClick()}
            >
              Realizar compromiso
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpiredDataComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/expired-data/ExpiredData.component.tsx